<div class="container-fluid container">
    <br>
    <h1>Contact</h1>
    <p>My email is  <a href="mailto:ramirezricky93@gmail.com">ramirezricky93@gmail.com</a></p>
    <!-- <p>My phone number is <a href="tel:+7734255388">773-425-5388</a></p> -->
</div>